import cntl from "cntl";
import { PropTypes } from "prop-types";
import { useMemo, useState, cloneElement } from "react";
import { COLOR, FEATURED_ICON_VARIANTS, SIZE } from "../constants";

const propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  classNameBanner: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  size: PropTypes.oneOf([SIZE.floating, SIZE["w-full"]]),
  color: PropTypes.oneOf([COLOR.primary, COLOR.dark, COLOR.grey]),
};

function Banner({ id, size, color, children, className, classNameBanner }) {
  const [shadow, setShadow] = useState("");
  const [border, setBorder] = useState("");
  const [rounded, setRounded] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [iconColor, setIconColor] = useState();
  const [textColor, setTextColor] = useState("");
  const [bannerSize, setBannerSize] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [iconVariant, setIconVariant] = useState();
  const [borderColor, setBorderColor] = useState("");
  const [widthContainer, setWidthContainer] = useState("");

  const bannerWrapperCn = () => cntl`
    flex-col
    lg:flex-row
    items-center
    justify-center
    ${border}
    ${shadow}
    ${rounded}
    ${bgColor}
    ${bannerSize}
    ${borderColor}
    ${className ? className : undefined}
  `;

  const bannerCn = () => cntl`
    ${widthContainer}
    ${classNameBanner ? classNameBanner : undefined}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.floating:
        setBorder("border");
        setShadow("shadow-xl");
        setRounded("rounded-xl");
        setBannerSize("max-w-[76rem] p-3");
        setWidthContainer("max-w-sm lg:max-w-full mx-auto px-8");
        break;
      case SIZE["w-full"]:
        setShadow("shadow-none");
        setRounded("rounded-none");
        setBannerSize("w-full py-3");
        setWidthContainer("max-w-3xl lg:max-w-7xl mx-auto px-8");
        setBorder("border-t lg:border-b lg:border-t-0");
        break;
      default:
        setShadow("shadow-none");
        setRounded("rounded-none");
        setBannerSize("w-full py-3");
        setWidthContainer("max-w-3xl lg:max-w-7xl mx-auto px-8");
        setBorder("border-t lg:border-b lg:border-t-0");
        break;
    }
  }, [size]);

  useMemo(() => {
    switch (color) {
      case COLOR.primary:
        setBgColor("bg-primary-25");
        setIconColor(COLOR.primary);
        setTextColor("text-primary-600");
        setTitleColor("text-primary-700");
        setBorderColor("border-primary-300");
        setIconVariant(FEATURED_ICON_VARIANTS.light_circle_outline);
        break;
      case COLOR.grey:
        setIconColor(COLOR.grey);
        setBgColor("bg-grey-25");
        setTextColor("text-grey-600");
        setTitleColor("text-grey-700");
        setBorderColor("border-grey-300");
        setIconVariant(FEATURED_ICON_VARIANTS.square);
        break;
      case COLOR.dark:
        setBorderColor("border-none");
        setIconColor(COLOR.primary);
        setTitleColor("text-white");
        setTextColor("text-primary-100");
        setIconVariant(FEATURED_ICON_VARIANTS.square);
        setBgColor("bg-gradient-to-br from-primary-700 to-primary-600");
        break;
      default:
        setBgColor("bg-primary-25");
        setIconColor(COLOR.primary);
        setTextColor("text-primary-600");
        setTitleColor("text-primary-700");
        setBorderColor("border-primary-300");
        setIconVariant(FEATURED_ICON_VARIANTS.light_circle_outline);
        break;
    }
  }, [color]);

  return (
    <div id={id} className={bannerWrapperCn()}>
      <div className={bannerCn()}>
        {cloneElement(children, {
          iconColor: iconColor,
          titleColor: titleColor,
          textColor: textColor,
          iconVariant: iconVariant,
        })}
      </div>
    </div>
  );
}

Banner.propTypes = propTypes;
export default Banner;
